(() => {
  const config = window.ChemistorsChatbotConfig || {};
  const apiBase = String(config.apiBase || 'https://webble.chemistors.com').replace(/\/+$/, '');
  const SESSION_KEY = 'chemistors_support_session_v4';
  const skipOtp = config.skipOtp === true;
  const brandName = config.brandName || 'Chemistors';
  const supportTitle = config.supportTitle || 'Chemistors Support';
  const launcherStyle = config.launcherStyle === 'support-avatar' ? 'support-avatar' : 'chat-bubble';
  const avatarImage = String(config.avatarImage || '').trim();
  const UI_VERSION = '20260315-1';

  const ISSUE_TYPES = ['Item Damaged / Defective', 'Item Missing', 'Wrong Item Received', 'Other Issue'];

  /* ─── Inject modern premium fonts ─── */
  if (!document.getElementById('chb-font')) {
    const link = document.createElement('link');
    link.id = 'chb-font';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Inter:wght@400;500&display=swap';
    document.head.appendChild(link);
  }

  /* ─── Inject premium styles ─── */
  {
    const prevCss = document.getElementById('chb-css');
    if (prevCss) prevCss.remove();
    const s = document.createElement('style');
    s.id = 'chb-css';
    s.setAttribute('data-ui-version', UI_VERSION);
    s.textContent = `
      #chb-root {
        all: initial;
        --pri: #0e9bd8;
        --pri-dark: #0b7db4;
        --pri-light: #e7f6ff;
        --canvas: #eef4f8;
        --surface: #ffffff;
        --surface-soft: #f6fafc;
        --border: #d8e3ec;
        --border-strong: #c4d5e3;
        --text: #1a2738;
        --text-s: #5a6d84;
        --text-d: #8ca0b7;
        --success: #12795e;
        --warn: #a76c10;
        --danger: #bc3838;
        --success-bg: #e8f6ef;
        --success-brd: #bfe7d2;
        --success-tx: #0f5a46;
        position: fixed !important;
        right: 24px !important;
        bottom: 24px !important;
        left: auto !important;
        top: auto !important;
        z-index: 2147483647;
        display: block;
        color: var(--text);
        font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        line-height: 1.4;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        pointer-events: none;
      }
      #chb-root *, #chb-root *::before, #chb-root *::after { box-sizing: border-box; margin: 0; padding: 0; }
      #chb-root button, #chb-root input, #chb-root textarea, #chb-root select {
        font: inherit;
        color: inherit;
        letter-spacing: normal;
        text-transform: none;
      }
      #chb-root button {
        appearance: none;
        -webkit-appearance: none;
      }
      #chb-root a { color: inherit; }

      #chb-root .chb-fab {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: visible;
        transition: transform 0.22s ease, box-shadow 0.22s ease, opacity 0.22s ease;
        pointer-events: auto;
      }
      #chb-root .chb-fab:hover { transform: translateY(-3px); }
      #chb-root .chb-fab:active { transform: scale(0.97); }
      #chb-root .chb-fab-closed {
        background: linear-gradient(145deg, #19a7e0 0%, #1094d2 58%, #0b82bf 100%);
        color: #fff;
        box-shadow: 0 18px 30px rgba(12, 88, 136, 0.34), inset 0 1px 0 rgba(255, 255, 255, 0.28);
      }
      #chb-root .chb-fab-closed > svg {
        width: 28px;
        height: 28px;
        stroke: currentColor;
        fill: none;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
      #chb-root .chb-fab-avatar {
        width: 72px;
        height: 72px;
        padding: 0;
        background: transparent;
        box-shadow: none;
      }
      #chb-root .chb-avatar-shell {
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
        border: 5px solid rgba(255, 255, 255, 0.96);
        box-shadow: 0 12px 28px rgba(10, 86, 126, 0.2);
        background: #cfe2f8;
      }
      #chb-root .chb-avatar-portrait {
        width: 100%;
        height: 100%;
        display: block;
      }
      #chb-root .chb-avatar-portrait-image {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
      #chb-root .chb-fab-open {
        opacity: 0;
        pointer-events: none;
        transform: scale(0.84);
      }
      #chb-root .chb-live-ring {
        position: absolute;
        top: 6px;
        right: -1px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 3px solid #fff;
        background: #37ce7b;
        box-shadow: 0 0 0 4px rgba(55, 206, 123, 0.18);
      }
      #chb-root .chb-live-ring::after {
        content: '';
        position: absolute;
        inset: -5px;
        border-radius: 50%;
        border: 2px solid rgba(40, 201, 133, 0.45);
        animation: chb-pulse 1.8s infinite ease-out;
      }

      #chb-root .chb-card {
        position: absolute;
        right: 0 !important;
        bottom: 84px !important;
        left: auto !important;
        top: auto !important;
        width: 396px;
        max-width: calc(100vw - 24px);
        height: 736px;
        max-height: calc(100vh - 104px);
        display: none;
        flex-direction: column;
        overflow: hidden;
        border-radius: 28px;
        border: 1px solid #d4e0e9;
        background:
          radial-gradient(circle at top left, rgba(71, 166, 211, 0.1) 0%, rgba(71, 166, 211, 0) 28%),
          linear-gradient(180deg, #f7fafc 0%, #eef4f8 100%);
        box-shadow: 0 28px 62px rgba(16, 36, 54, 0.23), 0 10px 22px rgba(16, 36, 54, 0.12);
        opacity: 0;
        transform: translateY(18px) scale(0.97);
        transform-origin: bottom right;
        transition: opacity 0.28s ease, transform 0.28s ease;
        pointer-events: auto;
      }
      #chb-root .chb-card.vis { display: flex; }
      #chb-root .chb-card.show { opacity: 1; transform: translateY(0) scale(1); }

      #chb-root .chb-hdr {
        position: relative;
        padding: 16px 16px 14px;
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        background:
          radial-gradient(circle at 88% 18%, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0) 24%),
          linear-gradient(135deg, #0d8ec8 0%, #12a4d6 54%, #129790 100%);
      }
      #chb-root .chb-hdr::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 1px;
        background: rgba(255, 255, 255, 0.22);
      }
      #chb-root .chb-hdr-logo {
        width: 44px;
        height: 44px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: rgba(255, 255, 255, 0.16);
        border: 1px solid rgba(255, 255, 255, 0.22);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);
      }
      #chb-root .chb-hdr-logo svg {
        width: 22px;
        height: 22px;
        fill: rgba(255, 255, 255, 0.96);
      }
      #chb-root .chb-hdr-info { flex: 1; min-width: 0; }
      #chb-root .chb-hdr-title {
        display: flex;
        align-items: center;
        gap: 7px;
        font-size: 18px;
        line-height: 1.1;
        font-weight: 700;
        color: #f8fdff;
        letter-spacing: 0.01em;
      }
      #chb-root .chb-hdr-title::after {
        content: '';
        width: 8px;
        height: 8px;
        flex-shrink: 0;
        border-radius: 50%;
        background: #36e28f;
        box-shadow: 0 0 10px rgba(54, 226, 143, 0.8);
      }
      #chb-root .chb-hdr-sub {
        margin-top: 4px;
        font-family: 'Inter', sans-serif;
        font-size: 12px;
        color: rgba(237, 247, 255, 0.92);
      }
      #chb-root .chb-hdr-close {
        width: 38px;
        height: 38px;
        border: none;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.15);
        color: rgba(255, 255, 255, 0.95);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        flex-shrink: 0;
        transition: transform 0.18s ease, background 0.18s ease;
      }
      #chb-root .chb-hdr-close:hover {
        background: rgba(255, 255, 255, 0.22);
        transform: rotate(90deg);
      }
      #chb-root .chb-hdr-close svg {
        width: 16px;
        height: 16px;
        stroke: currentColor;
        fill: none;
        stroke-width: 2.4;
        stroke-linecap: round;
      }

      #chb-root .chb-thread {
        flex: 1;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 14px;
        background:
          radial-gradient(circle at 92% 6%, rgba(14, 155, 216, 0.08) 0%, rgba(14, 155, 216, 0) 32%),
          linear-gradient(180deg, #f1f6fa 0%, #ebf1f6 100%);
        scrollbar-width: thin;
        scrollbar-color: #c4d0dc transparent;
      }
      #chb-root .chb-thread::-webkit-scrollbar { width: 5px; }
      #chb-root .chb-thread::-webkit-scrollbar-track { background: transparent; }
      #chb-root .chb-thread::-webkit-scrollbar-thumb {
        background: #c4d0dc;
        border-radius: 999px;
      }

      #chb-root .chb-msg {
        max-width: 80%;
        position: relative;
        animation: chb-msg-in 0.24s ease both;
      }
      #chb-root .chb-msg-bot { align-self: flex-start; }
      #chb-root .chb-msg-user { align-self: flex-end; }
      #chb-root .chb-bubble {
        padding: 11px 13px;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        line-height: 1.48;
        overflow-wrap: anywhere;
      }
      #chb-root .chb-msg-bot .chb-bubble {
        color: var(--text);
        background: #ffffff;
        border: 1px solid #dfe8f0;
        border-radius: 18px 18px 18px 8px;
        box-shadow: 0 5px 14px rgba(18, 40, 61, 0.08);
      }
      #chb-root .chb-msg-user .chb-bubble {
        color: #ffffff;
        background: linear-gradient(145deg, #16a8dd 0%, #0e90cb 100%);
        border-radius: 18px 18px 8px 18px;
        box-shadow: 0 8px 18px rgba(13, 115, 170, 0.26);
      }
      #chb-root .chb-bubble-success {
        background: var(--success-bg) !important;
        border-color: var(--success-brd) !important;
        color: var(--success-tx) !important;
      }
      #chb-root .chb-bubble-alert {
        background: #fff2f2 !important;
        border-color: #f1d0d0 !important;
        color: #8d2323 !important;
      }
      #chb-root .chb-msg-time {
        margin-top: 5px;
        padding: 0 8px;
        font-size: 11px;
        color: #8b9cb1;
        letter-spacing: 0.02em;
      }
      #chb-root .chb-msg-user .chb-msg-time { text-align: right; }

      #chb-root .chb-qr {
        display: grid;
        gap: 8px;
        width: 100%;
        margin-top: 2px;
      }
      #chb-root .chb-qr-btn {
        width: 100%;
        border: 1px solid var(--border);
        border-radius: 16px;
        background: rgba(255, 255, 255, 0.92);
        color: var(--text);
        text-align: left;
        cursor: pointer;
        display: grid;
        grid-template-columns: auto 1fr auto;
        align-items: center;
        gap: 10px;
        padding: 10px 11px;
        box-shadow: 0 6px 14px rgba(16, 36, 54, 0.055);
        transition: transform 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
      }
      #chb-root .chb-qr-btn:hover {
        transform: translateY(-1px);
        border-color: #abd8ef;
        background: #ffffff;
        box-shadow: 0 8px 18px rgba(16, 36, 54, 0.085);
      }
      #chb-root .chb-qr-icon {
        width: 30px;
        height: 30px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-size: 15px;
        background: linear-gradient(145deg, #e8f7ff 0%, #d8f0fb 100%);
        color: var(--pri-dark);
      }
      #chb-root .chb-qr-icon svg {
        width: 17px;
        height: 17px;
        stroke: currentColor;
        fill: none;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
      }
      #chb-root .chb-qr-label {
        min-width: 0;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.35;
        white-space: normal;
        overflow-wrap: anywhere;
      }
      #chb-root .chb-qr-arrow {
        width: 24px;
        height: 24px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--pri-light);
        color: var(--pri);
        font-size: 15px;
        line-height: 1;
      }

      #chb-root .chb-widget-box {
        width: 100%;
        align-self: stretch;
        border: 1px solid #d6e3ec;
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.96);
        box-shadow: 0 8px 18px rgba(16, 36, 54, 0.07);
        padding: 14px;
      }
      #chb-root .chb-widget-box.chb-msg {
        width: 100%;
        max-width: none;
      }
      #chb-root .chb-widget-title {
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 700;
        color: var(--text);
      }

      #chb-root .chb-phone-wrap,
      #chb-root .chb-form-inline {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      #chb-root .chb-phone-wrap {
        display: grid;
        grid-template-columns: 74px 1fr;
        margin-bottom: 12px;
      }
      #chb-root .chb-cc,
      #chb-root .chb-phone-input,
      #chb-root .chb-fi-input,
      #chb-root .chb-fi-textarea {
        width: 100%;
        border: 1px solid var(--border);
        border-radius: 12px;
        background: var(--surface-soft);
        color: var(--text);
        outline: none;
        transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
      }
      #chb-root .chb-cc {
        text-align: center;
        font-size: 14px;
        font-weight: 700;
        padding: 10px 8px;
      }
      #chb-root .chb-phone-input,
      #chb-root .chb-fi-input {
        padding: 10px 12px;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
      }
      #chb-root .chb-phone-input::placeholder,
      #chb-root .chb-fi-input::placeholder,
      #chb-root .chb-fi-textarea::placeholder { color: var(--text-d); }
      #chb-root .chb-fi-textarea {
        min-height: 96px;
        resize: vertical;
        padding: 10px 12px;
        font-family: 'Inter', sans-serif;
        font-size: 13px;
        line-height: 1.5;
      }
      #chb-root .chb-cc:focus,
      #chb-root .chb-phone-input:focus,
      #chb-root .chb-fi-input:focus,
      #chb-root .chb-fi-textarea:focus,
      #chb-root .chb-otp-digit:focus {
        border-color: #81c9eb;
        background: #ffffff;
        box-shadow: 0 0 0 4px rgba(14, 155, 216, 0.12);
      }
      #chb-root .chb-fi-label {
        margin-bottom: 5px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.05em;
        color: var(--text-s);
        text-transform: uppercase;
      }
      #chb-root .chb-primary-btn {
        width: 100%;
        min-height: 44px;
        border: none;
        border-radius: 14px;
        background: linear-gradient(145deg, #17abdd 0%, #0e8fc9 100%);
        color: #fff;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.04em;
        box-shadow: 0 12px 22px rgba(14, 143, 201, 0.28);
        transition: transform 0.18s ease, box-shadow 0.18s ease;
      }
      #chb-root .chb-primary-btn:hover {
        transform: translateY(-1px);
        box-shadow: 0 14px 28px rgba(14, 143, 201, 0.33);
      }
      #chb-root .chb-primary-btn:disabled {
        opacity: 0.56;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
      }
      #chb-root .chb-btn-row {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px;
      }
      #chb-root .chb-secondary-btn {
        width: 100%;
        min-height: 42px;
        border: 1px solid #d0dde8;
        border-radius: 14px;
        background: #f8fbfd;
        color: var(--text-s);
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.04em;
        transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
      }
      #chb-root .chb-secondary-btn:hover {
        transform: translateY(-1px);
        border-color: #bad1e1;
        background: #ffffff;
      }
      #chb-root .chb-ticket-tip {
        margin: 0 0 12px;
        padding: 12px 13px;
        border-radius: 14px;
        border: 1px solid #dbe6ef;
        background: #f8fbfd;
      }
      #chb-root .chb-ticket-tip strong {
        display: block;
        margin-bottom: 4px;
        font-size: 12px;
        font-weight: 700;
        color: var(--text);
      }
      #chb-root .chb-ticket-tip span {
        display: block;
        font-size: 12px;
        line-height: 1.5;
        color: var(--text-s);
      }
      #chb-root .chb-ticket-tip.awaiting {
        background: #fff8e8;
        border-color: #f0ddb1;
      }
      #chb-root .chb-ticket-tip.open {
        background: #eef8ff;
        border-color: #cfe5f3;
      }
      #chb-root .chb-ticket-tip.closed {
        background: #f5f7fa;
        border-color: #dce5ec;
      }

      #chb-root .chb-otp-wrap {
        display: flex;
        gap: 8px;
        justify-content: center;
        margin-bottom: 16px;
      }
      #chb-root .chb-otp-digit {
        width: 44px;
        height: 50px;
        border: 1px solid var(--border);
        border-radius: 12px;
        background: var(--surface-soft);
        text-align: center;
        font-size: 21px;
        font-weight: 700;
      }

      #chb-root .chb-file-meta {
        margin-top: 6px;
        font-family: 'Inter', sans-serif;
        font-size: 12px;
        color: var(--text-s);
      }

      #chb-root .chb-display-card {
        position: relative;
        overflow: hidden;
        border: 1px solid #d8e3ec;
        border-radius: 16px;
        background: #ffffff;
        padding: 13px 14px;
        box-shadow: 0 7px 16px rgba(18, 40, 61, 0.06);
      }
      #chb-root .chb-card-meta {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 5px;
      }
      #chb-root .chb-card-title {
        font-size: 13px;
        font-weight: 700;
        color: var(--text);
        line-height: 1.35;
      }
      #chb-root .chb-card-date {
        font-size: 12px;
        color: var(--text-d);
      }
      #chb-root .chb-card-highlight {
        font-size: 13px;
        font-weight: 700;
        color: var(--pri-dark);
      }
      #chb-root .chb-card-desc {
        font-family: 'Inter', sans-serif;
        font-size: 12px;
        line-height: 1.45;
        color: var(--text-s);
      }
      #chb-root .chb-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 22px;
        padding: 0 9px;
        border-radius: 999px;
        font-size: 10px;
        font-weight: 700;
        letter-spacing: 0.05em;
        text-transform: uppercase;
      }
      #chb-root .chb-b-ok { background: #dff5ea; color: var(--success); border: 1px solid #b8e5cf; }
      #chb-root .chb-b-warn { background: #fff2da; color: var(--warn); border: 1px solid #f1d59c; }
      #chb-root .chb-b-err { background: #ffe5e5; color: var(--danger); border: 1px solid #efb8b8; }
      #chb-root .chb-b-info { background: #e2f4ff; color: var(--pri-dark); border: 1px solid #b8def4; }
      #chb-root .chb-b-mute { background: #edf2f6; color: #60748b; border: 1px solid #d3dde7; }

      #chb-root .chb-faq {
        border: 1px solid #d8e3ec;
        border-radius: 14px;
        background: #ffffff;
        margin-bottom: 8px;
        box-shadow: 0 6px 16px rgba(18, 40, 61, 0.05);
      }
      #chb-root .chb-faq.exp { border-color: #aad7ee; }
      #chb-root .chb-faq-q {
        padding: 11px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        color: var(--text);
      }
      #chb-root .chb-faq-chev {
        width: 24px;
        height: 24px;
        border-radius: 999px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--pri-light);
        color: var(--pri);
        transition: transform 0.22s ease, background 0.22s ease, color 0.22s ease;
      }
      #chb-root .chb-faq.exp .chb-faq-chev {
        transform: rotate(180deg);
        background: var(--pri);
        color: #fff;
      }
      #chb-root .chb-faq-a {
        display: none;
        padding: 0 12px 12px;
        font-family: 'Inter', sans-serif;
        font-size: 12px;
        line-height: 1.55;
        color: var(--text-s);
      }
      #chb-root .chb-faq.exp .chb-faq-a {
        display: block;
        animation: chb-fade-in 0.18s ease;
      }

      #chb-root .chb-typing {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        min-width: 52px;
        justify-content: center;
      }
      #chb-root .chb-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: var(--pri);
        opacity: 0.74;
        animation: chb-bounce 0.95s infinite ease;
      }
      #chb-root .chb-dot:nth-child(2) { animation-delay: 0.12s; }
      #chb-root .chb-dot:nth-child(3) { animation-delay: 0.24s; }

      @keyframes chb-msg-in {
        from { opacity: 0; transform: translateY(8px); }
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes chb-bounce {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-4px); }
      }
      @keyframes chb-pulse {
        0% { opacity: 0.8; transform: scale(1); }
        100% { opacity: 0; transform: scale(2.25); }
      }
      @keyframes chb-fade-in {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @media (max-width: 680px) {
        #chb-root {
          left: auto !important;
          right: 12px !important;
          bottom: 12px !important;
          top: auto !important;
        }
        #chb-root .chb-card {
          left: auto !important;
          right: 0 !important;
          bottom: 72px !important;
          width: min(396px, calc(100vw - 24px));
          max-width: calc(100vw - 24px);
          height: calc(100vh - 92px);
          max-height: calc(100vh - 92px);
          border-radius: 22px;
        }
        #chb-root .chb-hdr {
          padding: 14px 12px 12px;
          gap: 8px;
        }
        #chb-root .chb-hdr-logo {
          width: 40px;
          height: 40px;
          border-radius: 12px;
        }
        #chb-root .chb-hdr-logo svg {
          width: 20px;
          height: 20px;
        }
        #chb-root .chb-hdr-title { font-size: 17px; }
        #chb-root .chb-hdr-sub { font-size: 11px; }
        #chb-root .chb-hdr-close {
          width: 36px;
          height: 36px;
          border-radius: 10px;
        }
        #chb-root .chb-thread {
          padding: 12px;
          gap: 10px;
        }
        #chb-root .chb-msg { max-width: 88%; }
        #chb-root .chb-bubble {
          padding: 10px 11px;
          font-size: 13px;
        }
        #chb-root .chb-qr { gap: 8px; }
        #chb-root .chb-qr-btn {
          padding: 9px 10px;
          gap: 8px;
        }
        #chb-root .chb-qr-icon {
          width: 28px;
          height: 28px;
          border-radius: 9px;
          font-size: 14px;
        }
        #chb-root .chb-qr-label {
          font-size: 12px;
        }
        #chb-root .chb-widget-box {
          padding: 12px;
          border-radius: 16px;
        }
        #chb-root .chb-phone-wrap {
          grid-template-columns: 68px 1fr;
        }
        #chb-root .chb-primary-btn {
          min-height: 42px;
          font-size: 12px;
        }
        #chb-root .chb-otp-digit {
          width: 40px;
          height: 46px;
          font-size: 18px;
        }
        #chb-root .chb-fab {
          width: 58px;
          height: 58px;
        }
      }
    `;
    document.head.appendChild(s);
  }

  /* ─── Utilities ─── */
  const esc = v => { const d = document.createElement('div'); d.appendChild(document.createTextNode(String(v || ''))); return d.innerHTML; };
  const fmtDate = v => { if (!v) return ''; try { return new Date(v).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' }); } catch { return ''; } };
  const fmtMoney = (v, c) => { try { return new Intl.NumberFormat('en-IN', { style: 'currency', currency: c || 'INR', maximumFractionDigits: 0 }).format(Number(v || 0)); } catch { return `₹${Number(v || 0)}`; } };
  const fmtTime = () => new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  const fmtStatus = v => String(v || '').toLowerCase().replaceAll('_', ' ').replace(/\b\w/g, m => m.toUpperCase());

  const deliveryBadge = (s) => {
    const u = String(s || '').toUpperCase();
    if (u === 'DELIVERED' || u === 'FULFILLED') return { c: 'chb-b-ok', t: 'Delivered' };
    if (u === 'CANCELLED') return { c: 'chb-b-err', t: 'Cancelled' };
    if (u === 'IN_TRANSIT' || u.includes('TRANSIT')) return { c: 'chb-b-info', t: 'In Transit' };
    return { c: 'chb-b-warn', t: 'Processing' };
  };

  const ticketBadge = (s) => {
    const u = String(s || '').toUpperCase();
    if (u === 'OPEN') return { c: 'chb-b-info', t: 'Open' };
    if (u === 'AWAITING_CUSTOMER') return { c: 'chb-b-warn', t: 'Awaiting' };
    if (u === 'RESOLVED') return { c: 'chb-b-ok', t: 'Resolved' };
    return { c: 'chb-b-mute', t: u || 'Closed' };
  };
  const ticketSortRank = (status) => {
    const u = String(status || '').toUpperCase();
    if (u === 'AWAITING_CUSTOMER') return 0;
    if (u === 'OPEN') return 1;
    if (u === 'RESOLVED') return 2;
    return 3;
  };
  const ticketListLabel = (ticket) => {
    const status = String(ticket?.status || '').toUpperCase();
    if (status === 'AWAITING_CUSTOMER') return `${ticket.id} • Reply Needed`;
    if (status === 'OPEN') return `${ticket.id} • In Progress`;
    if (status === 'RESOLVED') return `${ticket.id} • Resolved`;
    return `${ticket.id} • Closed`;
  };
  const ticketTip = (ticket) => {
    const status = String(ticket?.status || '').toUpperCase();
    const lastBy = String(ticket?.lastResponseBy || '').toUpperCase();
    if (status === 'AWAITING_CUSTOMER' && lastBy === 'ADMIN') {
      return {
        klass: 'awaiting',
        title: 'Support has replied',
        body: `Please reply on this ticket if you still need help. We also send the same update to ${esc(ticket?.userEmail || 'your inbox')}.`,
      };
    }
    if (status === 'OPEN' && lastBy === 'USER') {
      return {
        klass: 'open',
        title: 'Waiting on the support team',
        body: `Your latest message has been sent. We will notify you at ${esc(ticket?.userEmail || 'your inbox')} when support replies.`,
      };
    }
    if (status === 'RESOLVED') {
      return {
        klass: 'closed',
        title: 'Marked as resolved',
        body: 'If the issue is still not solved, you can reply on this ticket to reopen the conversation.',
      };
    }
    if (status === 'CLOSED') {
      return {
        klass: 'closed',
        title: 'Ticket is closed',
        body: 'You can still review the conversation here. If you need more help, reply on this ticket or create a fresh request from the main menu.',
      };
    }
    return {
      klass: 'open',
      title: 'Ticket is active',
      body: 'Open this ticket anytime to check updates, add attachments, or reply to support.',
    };
  };

  /* ─── Session ─── */
  const loadSession = () => { try { const r = localStorage.getItem(SESSION_KEY); return r ? JSON.parse(r) : null; } catch { return null; } };
  const saveSession = d => { try { localStorage.setItem(SESSION_KEY, JSON.stringify(d)); } catch { } };
  const clearSession = () => { try { localStorage.removeItem(SESSION_KEY); } catch { } };
  // 23-Sep-2026: the backend requires the verified chat token (JWT, 24h). A session without a
  // live token must go back through OTP instead of greeting "Welcome back" and failing.
  const tokenValid = sess => {
    const t = sess?.token;
    if (!t) return false;
    try {
      const p = JSON.parse(atob(t.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      return !p.exp || p.exp * 1000 > Date.now() + 60000;
    } catch { return false; }
  };

  /* ─── API ─── */
  async function api(path, opts = {}) {
    const headers = { ...(opts.headers || {}) };
    const sessToken = loadSession()?.token;
    if (sessToken) headers['Authorization'] = `Bearer ${sessToken}`;
    let body = undefined;

    if (opts.formData) {
      body = opts.formData;
    } else if (opts.body !== undefined) {
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
      body = JSON.stringify(opts.body);
    }

    const r = await fetch(`${apiBase}${path}`, {
      ...opts,
      headers,
      body,
    });
    const t = await r.text();
    let j = null; try { j = JSON.parse(t); } catch { }
    if (!r.ok) {
      if (r.status === 401 && !path.startsWith('/api/chatbot/auth/')) {
        clearSession();
        st.session = null;
        const expired = new Error('Your session has expired. Please verify your number again.');
        expired.status = 401;
        throw expired;
      }
      const err = new Error(j?.error || j?.message || `Failed (${r.status})`);
      err.status = r.status;
      err.details = j?.details || null;
      throw err;
    }
    return j;
  }

  /* ─── DOM Setup ─── */
  const closedFabClass = launcherStyle === 'support-avatar'
    ? 'chb-fab chb-fab-closed chb-fab-avatar'
    : 'chb-fab chb-fab-closed';
  const closedFabMarkup = () => launcherStyle === 'support-avatar'
    ? `
      <div class="chb-avatar-shell" aria-hidden="true">
        ${avatarImage
          ? `<img class="chb-avatar-portrait-image" src="${esc(avatarImage)}" alt="${esc(brandName)} support" loading="eager" decoding="async">`
          : `<svg class="chb-avatar-portrait" viewBox="0 0 64 64">
          <defs>
            <radialGradient id="chbAvatarBg" cx="50%" cy="34%" r="64%">
              <stop offset="0%" stop-color="#d9e8fb"/>
              <stop offset="100%" stop-color="#b7d0ee"/>
            </radialGradient>
            <linearGradient id="chbAvatarShirt" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#11627d"/>
              <stop offset="100%" stop-color="#0e536d"/>
            </linearGradient>
            <radialGradient id="chbSkin" cx="48%" cy="34%" r="62%">
              <stop offset="0%" stop-color="#d99768"/>
              <stop offset="100%" stop-color="#b86d3d"/>
            </radialGradient>
            <radialGradient id="chbHairSheen" cx="50%" cy="24%" r="58%">
              <stop offset="0%" stop-color="#414751"/>
              <stop offset="100%" stop-color="#161a20"/>
            </radialGradient>
            <linearGradient id="chbEyeBrown" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#5a381f"/>
              <stop offset="100%" stop-color="#3a2412"/>
            </linearGradient>
          </defs>
          <circle cx="32" cy="32" r="32" fill="url(#chbAvatarBg)"/>
          <path d="M15.8 63c2.6-8.4 8.2-13.1 16.2-13.1 7.9 0 13.6 4.7 16.2 13.1H15.8z" fill="url(#chbAvatarShirt)"/>
          <path d="M28.5 43.8h7v6.4h-7z" fill="#9f5e3b"/>
          <ellipse cx="14.9" cy="31.5" rx="2.4" ry="4.2" fill="#b86d3d"/>
          <ellipse cx="49.1" cy="31.5" rx="2.4" ry="4.2" fill="#b86d3d"/>
          <ellipse cx="32" cy="29.4" rx="16.2" ry="16.8" fill="url(#chbSkin)"/>
          <path d="M15.5 28.8c1.1-9.8 7.3-17.4 16.7-17.4 9.8 0 15.6 7 16.2 16.2-2.7-1-4.8-2.6-6.6-4.7-1.4-1.7-2.4-3.4-3.2-5.3-2.8 4.4-10.2 9.1-23.1 11.2z" fill="url(#chbHairSheen)"/>
          <path d="M18.7 20.7c2.3-5.2 7-8.8 13.5-9.3 7.2-.5 12.6 2.4 15.9 8.7-1.6-.5-3.1-.7-4.3-.6-4.3.3-8.1-1-11.2-3.8-2.3 3-6.9 4.9-13.9 5z" fill="#141920" opacity=".72"/>
          <circle cx="26.1" cy="29.9" r="5.2" fill="#fff"/>
          <circle cx="37.9" cy="29.9" r="5.2" fill="#fff"/>
          <circle cx="26.8" cy="30.2" r="3.2" fill="url(#chbEyeBrown)"/>
          <circle cx="37.2" cy="30.2" r="3.2" fill="url(#chbEyeBrown)"/>
          <circle cx="27.6" cy="29.1" r="1.1" fill="#fff"/>
          <circle cx="38" cy="29.1" r="1.1" fill="#fff"/>
          <path d="M20.8 24.2c1.9-1.1 4-1.4 6.2-1" fill="none" stroke="#42342a" stroke-width="2.1" stroke-linecap="round"/>
          <path d="M37.1 23.2c2.1-.3 4.1.2 5.8 1.4" fill="none" stroke="#42342a" stroke-width="2.1" stroke-linecap="round"/>
          <path d="M31.7 30.7c.4.9.2 1.9-.5 2.8h1.4" fill="none" stroke="#8f5530" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M27.2 37.2c1.4.9 3 1.4 4.8 1.4 1.7 0 3.3-.4 4.6-1.3" fill="none" stroke="#8e4925" stroke-width="2.1" stroke-linecap="round"/>
          <path d="M28.4 38.3c1 .6 2.3.8 3.6.8 1.2 0 2.5-.2 3.5-.8" fill="none" stroke="#fff3eb" stroke-width="1.6" stroke-linecap="round"/>
        </svg>`}
      </div>
      <div class="chb-live-ring" id="chb-live"></div>
    `
    : `
      <div class="chb-live-ring" id="chb-live"></div>
      <svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>
    `;
  const prevRoot = document.getElementById('chb-root');
  if (prevRoot) prevRoot.remove();
  const root = document.createElement('div');
  root.id = 'chb-root';
  root.setAttribute('data-ui-version', UI_VERSION);
  root.innerHTML = `
    <div class="chb-card" id="chb-card">
      <div class="chb-hdr">
        <div class="chb-hdr-logo">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 2.5l1.4 3.7 3.8 1.3-3.8 1.3L12 12.5l-1.3-3.7L6.9 7.5l3.8-1.3L12 2.5z"/>
            <path d="M18.4 10.2l.8 2.2 2.3.8-2.3.8-.8 2.2-.8-2.2-2.3-.8 2.3-.8.8-2.2z"/>
            <path d="M7.2 13.6l1.1 2.8 2.9 1-2.9 1L7.2 21l-1-2.6-2.9-1 2.9-1 1-2.8z"/>
          </svg>
        </div>
        <div class="chb-hdr-info">
          <div class="chb-hdr-title">${esc(supportTitle)}</div>
          <div class="chb-hdr-sub">Always here for you</div>
        </div>
        <button class="chb-hdr-close" id="chb-close">
          <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <div class="chb-thread" id="chb-thread"></div>
    </div>
    <button class="${closedFabClass}" id="chb-fab">${closedFabMarkup()}</button>
  `;
  document.body.appendChild(root);

  const $card = root.querySelector('#chb-card');
  const $fab = root.querySelector('#chb-fab');
  const $thread = root.querySelector('#chb-thread');
  const $close = root.querySelector('#chb-close');
  const getLive = () => root.querySelector('#chb-live');

  /* ─── State ─── */
  const st = {
    open: false,
    session: loadSession(),
    phone: { cc: '+91', num: '' },
    otp: ['', '', '', ''],
    data: { orders: [], tickets: [], faq: [] },
    issue: { type: '', orderNumber: '' },
    convoStarted: false
  };

  /* ─── Interactions ─── */
  const toggle = () => {
    const $live = getLive();
    st.open = !st.open;
    if (st.open) {
      $card.classList.add('vis');
      if ($live) $live.style.display = 'none';
      $fab.className = 'chb-fab chb-fab-open';
      $fab.innerHTML = '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
      requestAnimationFrame(() => requestAnimationFrame(() => $card.classList.add('show')));
      if (!st.convoStarted) startConversation();
    } else {
      $card.classList.remove('show');
      $fab.className = closedFabClass;
      $fab.innerHTML = closedFabMarkup();
      const $nextLive = getLive();
      if ($nextLive) $nextLive.style.display = 'block';
      setTimeout(() => $card.classList.remove('vis'), 400);
    }
  };
  $fab.addEventListener('click', toggle);
  $close.addEventListener('click', toggle);

  const scrollBtm = () => requestAnimationFrame(() => { $thread.scrollTop = $thread.scrollHeight; });
  const botToneClass = (html) => {
    const t = String(html || '').trim();
    if (t.startsWith('✅')) return ' chb-bubble-success';
    if (t.startsWith('⚠️') || t.startsWith('❌')) return ' chb-bubble-alert';
    return '';
  };

  const addBotMsg = (html, delay = 0) => new Promise(res => {
    const dots = document.createElement('div');
    dots.className = 'chb-msg chb-msg-bot';
    dots.innerHTML = '<div class="chb-bubble chb-typing"><span class="chb-dot"></span><span class="chb-dot"></span><span class="chb-dot"></span></div>';
    $thread.appendChild(dots); scrollBtm();

    setTimeout(() => {
      dots.remove();
      const el = document.createElement('div');
      el.className = 'chb-msg chb-msg-bot';
      el.innerHTML = `<div class="chb-bubble${botToneClass(html)}">${html}</div><div class="chb-msg-time">${brandName} • ${fmtTime()}</div>`;
      $thread.appendChild(el); scrollBtm();
      res();
    }, delay || (400 + Math.random() * 500));
  });

  const addUserMsg = (txt) => {
    const el = document.createElement('div');
    el.className = 'chb-msg chb-msg-user';
    el.innerHTML = `<div class="chb-bubble">${esc(txt)}</div><div class="chb-msg-time">${fmtTime()}</div>`;
    $thread.appendChild(el); scrollBtm();
  };

  const addWidget = (html) => {
    const w = document.createElement('div');
    w.className = 'chb-widget-box chb-msg chb-msg-bot'; w.innerHTML = html;
    $thread.appendChild(w); scrollBtm(); return w;
  };

  const addDisplayCard = (html) => {
    const w = document.createElement('div');
    w.innerHTML = html; w.style.animation = 'chb-msg-in 0.4s both';
    $thread.appendChild(w); scrollBtm(); return w;
  };

  const qrIconSvg = (key) => {
    if (key === 'support') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12a8 8 0 0 1 16 0v3a2 2 0 0 1-2 2h-2v-5h4"/><path d="M4 17h4v-5H4"/><path d="M10 20h4"/></svg>';
    }
    if (key === 'logout') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="M16 17l5-5-5-5"/><path d="M21 12H9"/></svg>';
    }
    if (key === 'home') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/></svg>';
    }
    if (key === 'reply') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 17l-5-5 5-5"/><path d="M4 12h9a7 7 0 0 1 7 7"/></svg>';
    }
    if (key === 'package') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 8 4.5-8 4.5L4 7.5 12 3Z"/><path d="M4 7.5V16.5L12 21l8-4.5V7.5"/><path d="M12 12v9"/></svg>';
    }
    if (key === 'note') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3h8l5 5v13H3V3h5"/><path d="M16 3v5h5"/><path d="M8 13h8"/><path d="M8 17h5"/></svg>';
    }
    return '';
  };

  const quickReplyIconMarkup = (option) => {
    const svg = qrIconSvg(option?.iconKey || '');
    if (svg) return `<span class="chb-qr-icon">${svg}</span>`;
    if (option?.icon) return `<span class="chb-qr-icon">${option.icon}</span>`;
    return '';
  };

  const askQuickReplies = (opts) => new Promise(res => {
    const wrap = document.createElement('div'); wrap.className = 'chb-qr';
    wrap.innerHTML = opts.map((o, i) => `
      <button class="chb-qr-btn" data-idx="${i}">
        ${quickReplyIconMarkup(o)}
        <span class="chb-qr-label">${esc(o.label)}</span>
        <span class="chb-qr-arrow">›</span>
      </button>`).join('');
    $thread.appendChild(wrap); scrollBtm();
    wrap.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
      wrap.remove(); const chosen = opts[b.dataset.idx];
      addUserMsg(chosen.label); res(chosen);
    }));
  });

  /* ─── Phone & OTP Forms ─── */
  const askPhone = () => new Promise(res => {
    const w = addWidget(`
      <div class="chb-widget-title">Login or Sign up</div>
      <div class="chb-phone-wrap">
        <input class="chb-cc" value="${esc(st.phone.cc)}" maxlength="4"/>
        <input class="chb-phone-input" type="tel" placeholder="Mobile Number" autofocus/>
      </div>
      <button class="chb-primary-btn">CONTINUE <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>
    `);
    const cc = w.querySelector('.chb-cc'), inp = w.querySelector('.chb-phone-input'), btn = w.querySelector('.chb-primary-btn');
    cc.addEventListener('input', e => { st.phone.cc = e.target.value; });
    inp.addEventListener('input', e => { st.phone.num = e.target.value.replace(/\D/g, ''); });
    inp.addEventListener('keydown', e => { if (e.key === 'Enter') btn.click(); });
    btn.addEventListener('click', () => {
      if (st.phone.num.length < 7) return;
      const full = `${st.phone.cc}${st.phone.num}`; w.remove(); addUserMsg(full); res(full);
    });
  });

  const askOtp = () => new Promise(res => {
    const w = addWidget(`
      <div class="chb-widget-title">Enter Verification Code</div>
      <div class="chb-otp-wrap">
        ${[0, 1, 2, 3].map(i => `<input class="chb-otp-digit" maxlength="1" inputmode="numeric" data-idx="${i}"/>`).join('')}
      </div>
      <button class="chb-primary-btn">VERIFY & LOGIN</button>
    `);
    const digs = w.querySelectorAll('input'), btn = w.querySelector('button');
    digs[0].focus();
    digs.forEach((d, i) => {
      d.addEventListener('input', e => { st.otp[i] = e.target.value; if (e.target.value && i < 3) digs[i + 1].focus(); });
      d.addEventListener('keydown', e => { if (e.key === 'Backspace' && !d.value && i > 0) digs[i - 1].focus(); if (e.key === 'Enter') btn.click(); });
    });
    btn.addEventListener('click', () => {
      const code = st.otp.join(''); if (code.length < 4) return;
      w.remove(); addUserMsg('••••'); res(code);
    });
  });

  /* ─── Conversational Flows ─── */
  const startConversation = async () => {
    st.convoStarted = true;
    if (st.session?.phone && !tokenValid(st.session)) { clearSession(); st.session = null; }
    if (st.session?.phone) {
      await addBotMsg(`Welcome back${st.session.name ? ', <strong>' + esc(st.session.name) + '</strong>' : ''}! ✨`);
      return menuFlow();
    }
    await addBotMsg(`Namaste! 👋 Welcome to <strong>${esc(brandName)}</strong>`);
    await addBotMsg('I can assist you with order tracking, support tickets, and product info.');
    await authFlow();
  };

  const authFlow = async () => {
    await addBotMsg('Please enter your mobile number to get started:');
    const phone = await askPhone();

    if (skipOtp) {
      await addBotMsg('Securing connection...');
      try {
        const d = await api('/api/chatbot/auth/quick-login', { method: 'POST', body: { phone } });
        st.session = { phone, userId: d.user?.id, name: d.user?.name, email: d.user?.email, token: d.token };
        saveSession(st.session);
        await addBotMsg(`Awesome! You're logged in as <strong>${esc(phone)}</strong>. ✅`);
        return menuFlow();
      } catch (e) { await addBotMsg(`⚠️ ${esc(e.message)}`); return authFlow(); }
    } else {
      await addBotMsg('Sending verification code...');
      try {
        await api('/api/chatbot/auth/send-otp', { method: 'POST', body: { phone } });
        await addBotMsg(`Sent a verification code to <strong>${esc(phone)}</strong>.`);
        while (true) {
          const code = await askOtp();
          await addBotMsg('Verifying...');
          try {
            const d = await api('/api/chatbot/auth/verify-otp', { method: 'POST', body: { phone, code } });
            st.session = { phone, userId: d.user?.id, name: d.user?.name, email: d.user?.email, token: d.token };
            saveSession(st.session);
            await addBotMsg('Verified! ✅ Welcome aboard.');
            return menuFlow();
          } catch (e) {
            await addBotMsg(`⚠️ ${esc(e.message)}`);
            const next = await askQuickReplies([
              { icon: '🔁', label: 'Try OTP Again', id: 'retry' },
              { icon: '📱', label: 'Change Number', id: 'change' },
            ]);
            if (next.id === 'change') return authFlow();
          }
        }
      } catch (e) { await addBotMsg(`⚠️ ${esc(e.message)}`); return authFlow(); }
    }
  };

  const menuFlow = async () => {
    if (!tokenValid(st.session)) {
      clearSession(); st.session = null;
      return authFlow();
    }
    await addBotMsg('How can I help you elevate your journey today?');
    const choice = await askQuickReplies([
      { iconKey: 'package', label: 'Track My Order', id: 'track' },
      { icon: '🛡️', label: 'Report a Problem', id: 'issue' },
      { icon: '✨', label: 'Product Information', id: 'faq' },
      { iconKey: 'support', label: 'My Support Tickets', id: 'tickets' },
      { icon: '🤝', label: 'Bulk Order Inquiry', id: 'bulk' },
      { icon: '💬', label: 'Something Else', id: 'help' },
      { iconKey: 'logout', label: 'Logout', id: 'logout' }
    ]);
    if (choice.id === 'track') return trackFlow();
    if (choice.id === 'issue') return issueFlow();
    if (choice.id === 'faq') return faqFlow();
    if (choice.id === 'tickets') return ticketsFlow();
    if (choice.id === 'bulk' || choice.id === 'help') return formFlow(choice.id);
    if (choice.id === 'logout') {
      clearSession(); st.session = null; st.phone = { cc: '+91', num: '' };
      await addBotMsg('You have been securely logged out. Peace and light! 🌟');
      return authFlow();
    }
  };

  /* ─── Track Flow ─── */
  const trackFlow = async () => {
    await addBotMsg('Pulling up your recent orders... 📦');
    try {
      const d = await api(`/api/chatbot/orders?phone=${encodeURIComponent(st.session.phone)}`);
      st.data.orders = d?.orders || [];
    } catch (e) { await addBotMsg(`⚠️ ${esc(e.message)}`); return backFlow(); }

    if (!st.data.orders.length) { await addBotMsg('No orders found for this phone number. 📭'); return backFlow(); }

    await addBotMsg(`Found <strong>${st.data.orders.length}</strong> order${st.data.orders.length > 1 ? 's' : ''}:`);
    const cards = st.data.orders.map(o => {
      const b = deliveryBadge(o.deliveryState);
      const items = (o.lineItems || []).map(l => `${l.title}${l.quantity > 1 ? ` x${l.quantity}` : ''}`).join(', ');
      return `<div class="chb-display-card" style="margin-bottom:8px">
        <div class="chb-card-meta"><div class="chb-card-title">${esc(o.name || o.orderNumber)}</div> <span class="chb-badge ${b.c}">${b.t}</span></div>
        <div class="chb-card-meta" style="margin-top:-6px"><span class="chb-card-date">${fmtDate(o.createdAt)}</span><span class="chb-card-highlight">${fmtMoney(o.totalPrice, o.currency)}</span></div>
        ${items ? `<div class="chb-card-desc">${esc(items)}</div>` : ''}
        ${o.trackUrl ? `<a href="${esc(o.trackUrl)}" target="_blank" style="display:inline-block; margin-top:10px; color:var(--pri); font-size:13px; font-weight:600; text-decoration:none;">🔗 Track Shipment →</a>` : ''}
      </div>`;
    }).join('');
    addDisplayCard(cards);
    return backFlow();
  };

  /* ─── FAQ Flow ─── */
  const faqFlow = async () => {
    await addBotMsg('Accessing our knowledge base... ✨');
    try {
      const d = await api('/api/chatbot/faq');
      st.data.faq = d?.items || [];
    } catch { await addBotMsg('Could not load FAQs.'); return backFlow(); }

    if (!st.data.faq.length) { await addBotMsg('No information available right now.'); return backFlow(); }

    const h = st.data.faq.map((f, i) => `
      <div class="chb-faq" data-fx="${i}">
        <div class="chb-faq-q"><span>${esc(f.question)}</span> <div class="chb-faq-chev"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M6 9l6 6 6-6"/></svg></div></div>
        <div class="chb-faq-a">${esc(f.answer)}</div>
      </div>
    `).join('');
    const w = addDisplayCard(`<div style="padding-bottom:2px">${h}</div>`);
    w.querySelectorAll('.chb-faq').forEach(el => el.querySelector('.chb-faq-q').addEventListener('click', () => {
      const exp = el.classList.contains('exp');
      w.querySelectorAll('.chb-faq').forEach(x => x.classList.remove('exp'));
      if (!exp) el.classList.add('exp');
    }));
    return backFlow();
  };

  /* ─── Tickets Flow ─── */
  const ticketDetailCardHtml = (ticket) => {
    const messages = Array.isArray(ticket?.messages) ? ticket.messages : [];
    const attachments = Array.isArray(ticket?.attachments) ? ticket.attachments : [];
    const tip = ticketTip(ticket);
    const timelineItems = messages.slice(-6).map((message) => {
      const sender = String(message?.sender || '').toUpperCase() === 'ADMIN' ? 'Support Team' : 'You';
      const at = fmtDate(message?.createdAt);
      const body = esc(message?.content || '').replace(/\n/g, '<br />');
      const messageAttachments = Array.isArray(message?.attachments) ? message.attachments : [];
      const attachmentHtml = messageAttachments.length > 0
        ? `<div style="margin-top:6px;">${messageAttachments
          .map((a) => `<div style="margin-bottom:4px;"><a href="${esc(a.url || a.path || '')}" target="_blank" rel="noopener" style="color:var(--pri);font-size:12px;text-decoration:none;">📎 ${esc(a.filename || 'Attachment')}</a></div>`)
          .join('')}</div>`
        : '';
      return `<div style="margin-bottom:10px;">
        <div style="font-size:11px;color:var(--text-d);margin-bottom:3px;">${esc(sender)}${at ? ` • ${esc(at)}` : ''}</div>
        <div style="font-size:13px;color:var(--text);line-height:1.45;">${body}${attachmentHtml}</div>
      </div>`;
    }).join('');

    const unlinkedAttachments = attachments.filter((attachment) => !attachment?.messageId);
    const attachmentLinks = unlinkedAttachments.length > 0
      ? `<div style="margin-top:12px;">
        <div style="font-size:11px;color:var(--text-d);margin-bottom:6px;">Other Attachments</div>
        ${unlinkedAttachments.map((a) => `<div style="margin-bottom:4px;"><a href="${esc(a.url || a.path || '')}" target="_blank" rel="noopener" style="color:var(--pri);font-size:12px;text-decoration:none;">📎 ${esc(a.filename || 'Attachment')}</a></div>`).join('')}
      </div>`
      : '';

    return `
      <div class="chb-display-card" style="margin-bottom:8px">
        <div class="chb-card-meta">
          <div class="chb-card-title">${esc(ticket?.id || 'Ticket')}</div>
          <span class="chb-badge ${ticketBadge(ticket?.status).c}">${esc(fmtStatus(ticket?.status || 'OPEN'))}</span>
        </div>
        <div class="chb-card-desc" style="margin-bottom:8px">${esc(ticket?.subject || '')}</div>
        <div class="chb-ticket-tip ${tip.klass}"><strong>${tip.title}</strong><span>${tip.body}</span></div>
        <div style="padding-top:8px;border-top:1px solid var(--border)">
          ${timelineItems || '<div class="chb-card-date">No messages yet.</div>'}
        </div>
        ${attachmentLinks}
      </div>
    `;
  };

  const ticketReplyFlow = async (ticket) => {
    const w = addWidget(`
      <div class="chb-widget-title">Reply to ${esc(ticket?.id || 'ticket')}</div>
      <div class="chb-form-inline">
        <div>
          <div class="chb-fi-label">Your Reply</div>
          <textarea class="chb-fi-textarea" id="chb-reply-msg" placeholder="Type your reply..."></textarea>
        </div>
        <div>
          <div class="chb-fi-label">Attachments (optional)</div>
          <input class="chb-fi-input" id="chb-reply-files" type="file" multiple />
          <div class="chb-file-meta" id="chb-reply-file-meta">No files selected</div>
        </div>
        <div class="chb-btn-row">
          <button class="chb-secondary-btn" id="chb-reply-back">Back to Ticket</button>
          <button class="chb-secondary-btn" id="chb-reply-menu">Main Menu</button>
        </div>
        <button class="chb-primary-btn" id="chb-reply-send">SEND REPLY</button>
      </div>
    `);

    const fileInput = w.querySelector('#chb-reply-files');
    const fileMeta = w.querySelector('#chb-reply-file-meta');
    const sendBtn = w.querySelector('#chb-reply-send');
    const messageInput = w.querySelector('#chb-reply-msg');
    const backBtn = w.querySelector('#chb-reply-back');
    const menuBtn = w.querySelector('#chb-reply-menu');

    const refreshFileMeta = () => {
      const count = fileInput?.files?.length || 0;
      fileMeta.textContent = count > 0 ? `${count} file${count === 1 ? '' : 's'} selected` : 'No files selected';
    };
    fileInput.addEventListener('change', refreshFileMeta);

    await new Promise(resolve => {
      backBtn.addEventListener('click', () => {
        w.remove();
        resolve('ticket');
      });
      menuBtn.addEventListener('click', () => {
        w.remove();
        resolve('menu');
      });
      sendBtn.addEventListener('click', async () => {
        const message = messageInput.value.trim();
        const files = Array.from(fileInput.files || []);
        if (!message && files.length === 0) return;

        sendBtn.disabled = true;
        backBtn.disabled = true;
        menuBtn.disabled = true;
        await addBotMsg('Sending your reply...');

        try {
          const formData = new FormData();
          formData.append('phone', st.session.phone);
          if (message) formData.append('message', message);
          files.forEach(file => formData.append('attachments', file));

          await api(`/api/chatbot/tickets/${encodeURIComponent(ticket.id)}/reply`, {
            method: 'POST',
            formData,
          });

          w.remove();
          addUserMsg(message || `Shared ${files.length} attachment${files.length === 1 ? '' : 's'}.`);
          await addBotMsg(`✅ Your reply has been added to <strong>${esc(ticket.id)}</strong>.`);
          await addBotMsg(`We will notify you on <strong>${esc(st.session?.email || ticket?.userEmail || 'your inbox')}</strong> when support replies.`);
          resolve('ticket');
        } catch (e) {
          await addBotMsg(`⚠️ ${esc(e.message)}`);
          sendBtn.disabled = false;
          backBtn.disabled = false;
          menuBtn.disabled = false;
        }
      });
    });
  };

  const ticketDetailFlow = async (ticketId) => {
    try {
      const detail = await api(`/api/chatbot/tickets/${encodeURIComponent(ticketId)}?phone=${encodeURIComponent(st.session.phone)}`);
      const ticket = detail?.ticket;
      if (!ticket) throw new Error('Ticket not found');

      addDisplayCard(ticketDetailCardHtml(ticket));
      const action = await askQuickReplies([
        { iconKey: 'reply', label: 'Reply to this Ticket', id: 'reply' },
        { iconKey: 'support', label: 'Back to Ticket List', id: 'list' },
        { iconKey: 'home', label: 'Back to Main Menu', id: 'menu' },
      ]);

      if (action.id === 'reply') {
        const next = await ticketReplyFlow(ticket);
        if (next === 'menu') return menuFlow();
        return ticketDetailFlow(ticket.id);
      }
      if (action.id === 'list') return ticketsFlow();
      return menuFlow();
    } catch (e) {
      await addBotMsg(`⚠️ ${esc(e.message)}`);
      return backFlow();
    }
  };

  const ticketsFlow = async () => {
    await addBotMsg('Checking your support tickets... 🎫');
    try {
      const d = await api(`/api/chatbot/tickets?phone=${encodeURIComponent(st.session.phone)}`);
      st.data.tickets = d?.tickets || [];
    } catch (e) { await addBotMsg(`⚠️ ${esc(e.message)}`); return backFlow(); }

    if (!st.data.tickets.length) {
      await addBotMsg('You do not have any support tickets yet.');
      const next = await askQuickReplies([
        { icon: '🛡️', label: 'Report a Problem', id: 'issue' },
        { iconKey: 'home', label: 'Back to Main Menu', id: 'menu' },
      ]);
      if (next.id === 'issue') return issueFlow();
      return menuFlow();
    }

    st.data.tickets.sort((a, b) => {
      const rankDiff = ticketSortRank(a?.status) - ticketSortRank(b?.status);
      if (rankDiff !== 0) return rankDiff;
      return new Date(b?.updatedAt || 0).getTime() - new Date(a?.updatedAt || 0).getTime();
    });

    await addBotMsg(`Found <strong>${st.data.tickets.length}</strong> ticket${st.data.tickets.length === 1 ? '' : 's'}. Reply Needed tickets are shown first.`);
    const options = st.data.tickets.slice(0, 8).map(t => ({
      iconKey: 'support',
      label: ticketListLabel(t),
      id: t.id,
    }));
    options.push({ iconKey: 'home', label: 'Back to Main Menu', id: 'menu' });

    const picked = await askQuickReplies(options);
    if (picked.id === 'menu') return menuFlow();
    return ticketDetailFlow(picked.id);
  };

  /* ─── Issue Flow ─── */
  const issueFlow = async () => {
    await addBotMsg('I am really sorry you faced an issue. 🙏 Let\'s get this fixed.');
    await addBotMsg('What type of problem are you experiencing?');
    const type = await askQuickReplies(ISSUE_TYPES.map(t => ({ label: t, id: t })));
    st.issue.type = type.id;
    st.issue.orderNumber = '';

    await addBotMsg('Let me fetch your recent orders so we can tag this issue correctly.');
    try {
      const d = await api(`/api/chatbot/orders?phone=${encodeURIComponent(st.session.phone)}`);
      const orders = Array.isArray(d?.orders) ? d.orders : [];
      const deliveredOrders = orders.filter((order) => {
        const state = String(order?.deliveryState || '').toUpperCase();
        return state === 'DELIVERED' || state === 'FULFILLED';
      });
      const optionsSource = deliveredOrders.length > 0 ? deliveredOrders : orders;

      if (optionsSource.length > 0) {
        const orderChoice = await askQuickReplies([
          ...optionsSource.slice(0, 6).map((order) => ({
            iconKey: 'package',
            id: String(order?.orderNumber || order?.name || '').trim(),
            label: `${String(order?.orderNumber || order?.name || 'Order')} • ${fmtDate(order?.createdAt)}`,
          })),
          { iconKey: 'note', id: 'no-order', label: 'Issue not linked to an order' },
        ]);
        if (orderChoice.id !== 'no-order') {
          st.issue.orderNumber = orderChoice.id;
        }
      }
    } catch {
      // Order tagging is optional; continue with issue form.
    }

    return formFlow('issue');
  };

  /* ─── Form Flows (Help, Bulk, Issue) ─── */
  const formFlow = async (type) => {
    if (type !== 'issue') await addBotMsg('I\'ll collect a few details and connect you with our experts. 🤝');
    const title = type === 'bulk' ? 'Bulk Inquiry Form' : type === 'issue' ? 'Report Issue' : 'Support Request';
    let blockedTicketId = '';

    try {
      const existing = await api(`/api/chatbot/tickets?phone=${encodeURIComponent(st.session.phone)}`);
      const activeTicket = Array.isArray(existing?.tickets) ? existing.tickets[0] : null;
      if (activeTicket?.id) {
        blockedTicketId = String(activeTicket.id).trim();
        await addBotMsg(`⚠️ You already have an active ticket <strong>${esc(blockedTicketId)}</strong>. Please continue on that ticket instead of creating a new one.`);
        const next = await askQuickReplies([
          { iconKey: 'support', label: `Open ${blockedTicketId}`, id: 'open-active' },
          { iconKey: 'home', label: 'Back to Main Menu', id: 'menu' },
        ]);
        if (next.id === 'open-active') return ticketDetailFlow(blockedTicketId);
        return menuFlow();
      }
    } catch {
      // If lookup fails, fall back to submit-time handling.
    }

    const w = addWidget(`
      <div class="chb-widget-title">${title}</div>
      <div class="chb-form-inline">
        <div>
          <div class="chb-fi-label">Contact Address</div>
          <input class="chb-fi-input" id="chb-em" type="email" value="${esc(st.session?.email || '')}" placeholder="Enter your contact address"/>
        </div>
        <div>
          <div class="chb-fi-label">Attachments (optional)</div>
          <input class="chb-fi-input" id="chb-files" type="file" multiple />
          <div class="chb-file-meta" id="chb-file-meta">No files selected</div>
        </div>
        <div>
          <div class="chb-fi-label">Description</div>
          <textarea class="chb-fi-textarea" id="chb-desc" placeholder="Please provide details..."></textarea>
        </div>
        <div class="chb-btn-row">
          <button class="chb-secondary-btn" id="chb-form-menu">Back to Main Menu</button>
          <button class="chb-secondary-btn" id="chb-form-tickets">My Tickets</button>
        </div>
        <button class="chb-primary-btn" id="chb-sub">SUBMIT TICKET</button>
      </div>
    `);

    const formResult = await new Promise(res => {
      const fileInput = w.querySelector('#chb-files');
      const fileMeta = w.querySelector('#chb-file-meta');
      const submitBtn = w.querySelector('#chb-sub');
      const menuBtn = w.querySelector('#chb-form-menu');
      const ticketsBtn = w.querySelector('#chb-form-tickets');
      const refreshFileMeta = () => {
        const count = fileInput?.files?.length || 0;
        fileMeta.textContent = count > 0 ? `${count} file${count === 1 ? '' : 's'} selected` : 'No files selected';
      };
      fileInput.addEventListener('change', refreshFileMeta);
      menuBtn.addEventListener('click', () => {
        w.remove();
        res({ next: 'menu' });
      });
      ticketsBtn.addEventListener('click', () => {
        w.remove();
        res({ next: 'tickets' });
      });

      submitBtn.addEventListener('click', async () => {
        const em = w.querySelector('#chb-em').value.trim();
        const desc = w.querySelector('#chb-desc').value.trim();
        const files = Array.from(fileInput.files || []);
        if (!em || !desc) return;
        submitBtn.disabled = true;
        menuBtn.disabled = true;
        ticketsBtn.disabled = true;
        await addBotMsg('Processing your request... ⚙️');
        try {
          const formData = new FormData();
          formData.append('phone', st.session.phone);
          formData.append('userEmail', em);
          formData.append('name', st.session.name || '');
          formData.append('subject', type === 'issue' ? `Issue: ${st.issue.type}` : type === 'bulk' ? 'Bulk Inquiry' : 'General Help');
          formData.append('description', desc);
          formData.append('context', 'chatbot');
          if (type === 'issue' && st.issue.orderNumber) {
            formData.append('orderNumber', st.issue.orderNumber);
          }
          files.forEach(file => formData.append('attachments', file));

          const resAPI = await api('/api/tickets', {
            method: 'POST',
            formData,
          });
          w.remove();
          st.session = { ...st.session, email: em };
          saveSession(st.session);
          addUserMsg(desc);
          await addBotMsg(`✅ Success! Ticket <strong>${esc(resAPI?.ticket?.id || 'created')}</strong> has been submitted.`);
          await addBotMsg(`We will notify you on <strong>${esc(em)}</strong> whenever support replies. You can also open this ticket anytime from My Support Tickets.`);
          res({ next: 'created', ticketId: resAPI?.ticket?.id || '' });
        } catch (e) {
          blockedTicketId = String(e?.details?.activeTicket?.id || '').trim();
          if (e?.status === 409 && blockedTicketId) {
            w.remove();
            await addBotMsg(`⚠️ You already have an active ticket <strong>${esc(blockedTicketId)}</strong>. Please continue on that ticket instead of creating a new one.`);
            res({ next: 'blocked', ticketId: blockedTicketId });
          } else {
            await addBotMsg(`⚠️ ${esc(e.message)}`);
            submitBtn.disabled = false;
            menuBtn.disabled = false;
            ticketsBtn.disabled = false;
          }
        }
      });
    });
    if (formResult?.next === 'menu') return menuFlow();
    if (formResult?.next === 'tickets') return ticketsFlow();
    if (formResult?.next === 'created' && formResult.ticketId) {
      const next = await askQuickReplies([
        { iconKey: 'support', label: `Open ${formResult.ticketId}`, id: 'open-new' },
        { iconKey: 'home', label: 'Back to Main Menu', id: 'menu' },
      ]);
      if (next.id === 'open-new') return ticketDetailFlow(formResult.ticketId);
      return menuFlow();
    }
    if (blockedTicketId) {
      const next = await askQuickReplies([
        { iconKey: 'support', label: `Open ${blockedTicketId}`, id: 'open-active' },
        { iconKey: 'home', label: 'Back to Main Menu', id: 'menu' },
      ]);
      if (next.id === 'open-active') return ticketDetailFlow(blockedTicketId);
      return menuFlow();
    }
    return backFlow();
  };

  /* ─── Back to Menu ─── */
  const backFlow = async () => {
    if (!st.session) return authFlow();
    const c = await askQuickReplies([{ iconKey: 'home', label: 'Back to Main Menu', id: 'menu' }]);
    if (c.id === 'menu') return menuFlow();
  };

})();
